import styled from "styled-components";
import { ToggleSelect } from "@loanbossinc/component-library";

export const StyledSecondaryButtonWrapper = styled.div`
  float: right;
`;

export const OuterWrapper = styled.div`

  background: ${props => (props.isPrivate ? "#ffffff" : "#FAD4CE")};
  border: 1px solid;
  border-color: ${props => (props.isPrivate ? "#DADCE0" : "#0F9AD6")};

  box-sizing: border-box;
  padding: 20px 24px;

  display: flex;
  flex-direction: column;
  &:hover {
    background-color: #f0f0f0
  }

  .item-actions {
    padding: 24px;
    border-top: 1px solid #DADCE0;
  }

  .item-content {
    padding: 20px 24px;
    display: flex;
  }
`;

export const PublicLabel = styled.div`
  color: #c40a0a;
`;

export const DeleteWrapper = styled.div`
  float: right;
  cursor: pointer;
  color: #5f6368;
  margin-left: 24px;
`;

const baseFont = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
`;

export const FileWrapper = styled(baseFont)`
  color: #000000;
  margin-right: auto;
  margin-left: 10px;
  cursor: ${props => (props.cursorPointer ? "pointer" : "default")};
`;

export const SubTitleWrapper = styled(baseFont)`
  display: flex;
  flex-direction: row;
  font-size: 12px;
  opacity: 0.5;
  padding-top: 5px;
`;

export const StyledToggleSelect = styled(ToggleSelect)`
  &&{
    .Mui-selected {
      background-color: ${props => (props.isPrivate ? "#5F6368" : "#0F9AD6")}
      color: #fff;
    }
  }
`;
